import React, { useState } from 'react';
import '../styles/App.css';
import utils from '../utils/utils';

export default function LoginPage({ onLogin }) {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!username.trim() || !password.trim()) {
            setError('אנא הזן שם משתמש וסיסמה');
            return;
        }

        try {
            setLoading(true);
            const resp = await utils.requestData('BOSignIn', { username, password });
            console.log("Login response:", resp[1]?.[0]);
            if (resp[0][0].code == 0) {
                    localStorage.setItem("auth-token", resp[1][0].token);
                    setSuccess('התחברת בהצלחה, מעביר אותך למערכת...');

                    // השהיה קצרה כדי שהודעת ההצלחה תספיק להיראות - בלי זה
                    // המעבר ל-MainPage מיידי ואף אחד לא רואה שההתחברות הצליחה
                    setTimeout(() => {
                        onLogin(username, resp[1][0].role);
                        setUsername('');
                        setPassword('');
                    }, 700);
            }else {
                setError(resp[0][0].msg || 'שגיאה בהתחברות');
                setLoading(false);
            }
        } catch (error) {
            console.error("Login error:", error);
            setError('שגיאה בתקשורת עם השרת');
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-wrapper">

                <div className="login-header">
                    <div className="login-icon-container">
                        <div className="login-icon-box">🎫</div>
                    </div>
                    <h1 className="login-title">איגוד</h1>
                    <p className="login-subtitle">בק אופיס ניהול</p>
                </div>

                <div className="login-card">
                    <form onSubmit={handleLogin} className="login-form">
                        <div className="form-group">
                            <label className="form-label">שם משתמש</label>
                            <input
                                type="text"
                                placeholder="הזן שם משתמש"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="form-input"
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label">סיסמה</label>
                            <input
                                type="password"
                                placeholder="הזן סיסמה"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="form-input"
                            />
                        </div>

                        {error && <div className="error-message">{error}</div>}
                        {success && <div className="success-message">{success}</div>}

                        <button type="submit" className="login-btn" disabled={loading}>
                            {loading ? 'מתחבר...' : 'התחברות'}
                        </button>
                    </form>


                </div>

                <p className="login-footer">© 2026 איגוד - בק אופיס</p>
            </div>
        </div>
    );
}